import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        position: 'relative',
        display: 'flex',
        // Mobile - image below content
        flexDirection: 'column-reverse',
        placeContent: 'center',
        overflow: 'hidden',
    },
    message: Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), { color: _params.isFullWidthImage ? colors.supplementary.white : colors.black[700], textAlign: 'left', [theme.breakpoints.up('md')]: {
            color: colors.black[700],
        } }), theme.typographySpacing.small_regular_lg), { [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.medium_regular), [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.large_regular) }),
    heading: Object.assign(Object.assign(Object.assign({ display: 'flex', flexDirection: 'column' }, theme.typography.xl_regular), theme.typographySpacing.none), { color: colors.supplementary.white, marginBottom: spacing.small, textTransform: theme.isFlyingFlowers ? 'uppercase' : 'none', [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl), { marginBottom: spacing.medium }), [theme.breakpoints.up('lg')]: Object.assign(Object.assign({}, theme.typography.xxxxl), { marginBottom: spacing.large }) }),
    subheading: Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), { margin: 0 }), theme.typographySpacing.large_bold_lg), { marginBottom: `${theme.typographySpacing.large_bold_lg.marginBottom} !important`, textAlign: 'left', color: _params.isFullWidthImage ? colors.supplementary.white : colors.black[700], [theme.breakpoints.up('sm')]: Object.assign({ textAlign: 'left' }, theme.typographySpacing.large_bold_lg), [theme.breakpoints.up('md')]: Object.assign({}, theme.typographySpacing.large_bold_lg), [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.large_bold), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_lg) }),
    ffMobileheight: {
        [theme.breakpoints.down('sm')]: {
            minHeight: '640px',
            placeContent: 'start',
        },
    },
    imageFit: {
        [`&  img`]: {
            objectFit: 'cover',
        },
    },
    mobileImage: {
        position: 'unset !important ',
        [`&  img`]: {
            objectFit: (_params === null || _params === void 0 ? void 0 : _params.isFullWidthImage) ? 'cover!important' : 'contain !important',
            objectPosition: 'bottom',
        },
    },
    squareImage: {
        [`&  img`]: {
            paddingTop: '0px',
            position: 'absolute',
            width: '50%',
            height: '100%',
            right: '0px',
            top: '0px',
            objectFit: 'contain !important',
            objectPosition: 'bottom right',
        },
    },
    headingLine: {
        whiteSpace: 'nowrap',
        alignSelf: 'flex-start',
        padding: spacing.xs,
        '&:first-child': {
            transform: 'rotate(358deg) translate(5px,5px)',
            transformOrigin: 'bottom left',
        },
    },
    COBALT: {
        backgroundColor: colors.cobalt[500],
    },
    JADE: {
        backgroundColor: colors.jade[500],
    },
    WILD_EXOTIC: {
        backgroundColor: colors.wildExotic[500],
    },
    centerHeading: {
        alignSelf: 'center',
    },
    image: {},
    content: {
        [theme.breakpoints.up('sm')]: {},
    },
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
            [`& .${classes.image} img`]: {
                objectPosition: 'bottom right',
            },
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            [`& .${classes.content}`]: {
                justifyContent: 'right',
            },
            [`&  img`]: {
                objectPosition: 'bottom left',
            },
        },
    },
    positionCenter: {
        [theme.breakpoints.up('sm')]: {
            [`& .${classes.content}`]: {
                width: '100%',
            },
            [`&  img`]: {
                objectPosition: 'bottom',
            },
        },
    },
    ffCenterContentInner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    linkContainerClass: {
        display: 'inline-flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xs')]: {
            display: 'inline-flex', // this is to override the default display of the parent
            flexDirection: 'column',
        },
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            flexDirection: 'row',
            margin: `0 -${spacing.xs}`,
            [`& .${classes.linkClass}`]: {
                flexDirection: 'column',
                flexGrow: (_params === null || _params === void 0 ? void 0 : _params.contentPosition) == 'CENTER' ? 1 : 0,
            },
        },
        '& button': { width: '100%' },
    },
    linkClass: {
        width: '100%',
        display: 'flex',
        marginBottom: spacing.small,
        '&:last-child': {
            marginBottom: 0,
        },
        '& button': {
            flexGrow: 1,
            whiteSpace: 'pre-wrap',
        },
        [theme.breakpoints.up('md')]: {
            width: _params.linksCount === 1 ? '100%' : '50%',
            '& button': { width: '100%' },
            '&:not(:last-child)': {
                marginBottom: '0px',
                marginRight: spacing.small,
            },
        },
        [theme.breakpoints.up('lg')]: {
            width: '50%',
        },
    },
}));
export default useStyles;
